module.exports = __webpack_public_path__ + "img/logo-the-lobby-fizeaustraat--dark.bd0373dbd1b2830e8794e4ebedb38671.svg";